const spinnerId = "spinner";
const visibleClass = "spinner--visible";

const getSpinner = () => {
  return document.getElementById(spinnerId);
};

export const showSpinner = () => {
  const s = getSpinner();
  s?.classList.add(visibleClass);

  console.log("showing spinner");
};

export const hideSpinner = () => {
  const s = getSpinner();
  s?.classList.remove(visibleClass);

  console.log("hiding spinner");
};
